<template>
  <div>
    <Header />

    <section class="loading-container" v-if="order==''">
      <img
          :src='require("@/assets/images/ajax-loader.gif")'
          class="img-fluid bg-img"
      />
    </section>

    <section class="section-b-space pb-0 mt-5" v-if="order!=''">
      <div class="container">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="success-text">
              <h2><span>order submitted</span> <img :src='"@/assets/images/subtract.svg"' class="ml-2" alt="check" width="56" /></h2>
              <p>You will receive an email from steve@frootbrand.com with an order confirmation and estimated delivery date.</p>
            </div>
            <div class="text-right mr-md-5 mt-5">
              <router-link class="btn delivery-btn delivery-small-btn" to="/shop">Home</router-link>
            </div>
          </div>
        </div>
        <hr class="my-5" />
      </div>
    </section>

    <!-- Bootstrap Modal for Popup - Placed at root level for full overlay -->
    <div
        class="modal fade"
        ref="popupModal"
        tabindex="-1"
        role="dialog"
        :class="{ show: showPopup, 'd-block': showPopup }"
        style="display: none;"
        v-if="showPopup"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Enter your phone number for exclusive deals, bonus point offerings.<br>Get 500 points added to your account by entering!</h5>
            <button type="button" class="close" @click="closePopup" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input
                type="text"
                v-model="popupText"
                placeholder="Please enter your phone#"
                class="form-control"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="sendFunction">Send</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Backdrop (required for overlay) -->
    <div
        v-if="showPopup"
        class="modal-backdrop fade show"
        @click="closePopup"
    ></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Header from '@/components/header'
export default {
  components: {
    Header,
  },
  computed: {
    ...mapState({
      order_id: state=>state.cart.order_id,
      message: state=>state.cart.message,
      last_order: state=>state.cart.last_order,
    }),
    ...mapGetters({
      order: 'cart/ordered',
      getDetail: 'products/getProductByProductId',
      webTotalTitle: 'cart/webTotalTitle',
      signed_in_as_web_user:'auth/webUserAuthed',
      popup_phone: 'auth/popup_phone', // Maps the getter for popup control
      send_promo_phone_number_result: 'cart/send_promo_phone_number_result',
    })
  },
  data() {
    return {
      popupText: '', // Local data for input binding
      showPopup: false, // Local flag for immediate UI control
    };
  },
  mounted() {
    // Handle initial state: Show popup if popup_phone is already truthy on load
    if (this.popup_phone) {
      this.$nextTick(() => {
        this.showPopup = true;
        const modal = this.$refs.popupModal;
        if (modal) {
          // CSS fallback
          modal.classList.add('show', 'd-block');
          modal.style.display = 'block';
          document.body.classList.add('modal-open'); // Prevent body scroll
        }
      });
    }
  },
  watch: {
    popup_phone(newVal) {
      if (newVal && !this.showPopup) { // Only show if not already showing
        // Show modal (CSS-only for reliability; assumes Bootstrap CSS is loaded)
        this.$nextTick(() => {
          this.showPopup = true;
          const modal = this.$refs.popupModal;
          if (modal) {
            modal.classList.add('show', 'd-block');
            modal.style.display = 'block';
            document.body.classList.add('modal-open'); // Prevent body scroll
          }
        });
      } else if (!newVal && this.showPopup) {
        this.showPopup = false;
        this.hideModal();
      }
    },
  },
  methods: {
    hideModal() {
      const modal = this.$refs.popupModal;
      if (modal) {
        modal.classList.remove('show', 'd-block');
        modal.style.display = 'none';
        document.body.classList.remove('modal-open');
      }
    },
    closePopup() {
      // Immediate local hide for UI (modal and backdrop via v-if="showPopup")
      this.showPopup = false;
      this.hideModal();
      // Sync store (commit after local hide; adjust mutation name if needed)
      this.$store.commit('auth/setPopupPhone', 0);
    },
    sendFunction() {
      // Handle sending the popupText value (e.g., API call, then dispatch action)
      // Close the popup via local and store

      this.$store.dispatch('cart/sendPromoPhoneNumber', { 'text': this.popupText})


      this.closePopup();
      this.popupText = ''; // Reset local input
    },
  },
  beforeUnmount() {
    // Cleanup on unmount
    document.body.classList.remove('modal-open');
  },
}
</script>

<style scoped>
/* Ensure modal overlays properly */
.modal {
  display: none; /* Hidden by default */
}
.modal.show {
  display: block;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
  transition: opacity 0.15s linear;
}
.modal-backdrop.show {
  opacity: 0.5;
}
.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
  max-width: 700px; /* Adjust for middle-screen centering */
  margin: 10.75rem auto; /* Center vertically/horizontally */
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
.modal.fade.show .modal-dialog {
  transform: translate(0, 0);
}

/* Improved dialog design: Better spacing around text, remove horizontal line */
.modal-header {
  border-bottom: none; /* Remove horizontal line/border */
  padding: 2rem 2rem 1.5rem; /* Increased top/bottom padding for better "bleed" around title */
  text-align: center; /* Center title for better visual balance */
}
.modal-title {
  font-size: 1.25rem; /* Slightly larger for readability */
  line-height: 1.4; /* Improved line height for multi-line text */
  margin-bottom: 0; /* No extra margin */
  color: #333; /* Darker text for contrast */
}
.modal-body {
  padding: 0 2rem 1.5rem; /* Consistent padding with header, more space around input */
}
.modal-footer {
  padding: 0 2rem 2rem; /* Increased bottom padding for better spacing below button */
  border-top: none; /* Ensure no top border if present */
  justify-content: center; /* Center the Send button */
}
.form-control {
  border-radius: 0.5rem; /* Slightly rounded for modern look */
  border: 1px solid #ccc; /* Subtle border */
  padding: 0.75rem 1rem; /* More internal padding for text */
  font-size: 1rem; /* Readable size */
}
.btn-primary {
  background-color: #007bff; /* Bootstrap primary, or customize */
  border-color: #007bff;
  padding: 0.75rem 2rem; /* Wider button for better click area */
  border-radius: 0.5rem;
  font-weight: 500;
}
.close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.5rem;
  opacity: 0.5;
  transition: opacity 0.15s;
}
.close:hover {
  opacity: 0.8;
}
</style>
